export default __webpack_public_path__ + "static/media/nomIconRow.a98fc1f3.svg";